import {PRODUCT_TYPE} from '../constants';
import {Day, Menu, MenuState, Product, Service, Zone} from '../interfaces';
import {hasMenus, isActivatedComment} from '../tools';

export const getters = {
  isActivatedComment: (state: MenuState): boolean =>
    isActivatedComment(state.currentMenu, state.selectedService),
  currentMenu: (state: MenuState): Menu | null => state.currentMenu,
  day: (state: MenuState): Day | null => state.selectedDay,
  days: (state: MenuState): Day[] => state.days,
  error: (state: MenuState): boolean => state.error,
  formulaZones: (state: MenuState): Zone[] => state.zones.filter((zone) => zone.formula),
  formulaPrice:
    (state: MenuState) =>
    (code: string): number | null =>
      getters
        .currentMenu(state)
        ?.products?.filter(
          (product) => product.type === PRODUCT_TYPE.FOR && product.zoneCode === code
        )[0].price || null,
  formulaProducts:
    (state: MenuState) =>
    (code: string): Product[] =>
      getters
        .currentMenu(state)
        ?.products?.filter(
          (product) => product.type !== PRODUCT_TYPE.FOR && product.zoneCode === code
        ) || [],
  hasProducts:
    (state: MenuState) =>
    (service: Service): boolean =>
      hasMenus(state.menus, state.selectedDay, service),
  loadingMenu: (state: MenuState): boolean => state.loading,
  menus: (state: MenuState): Menu[] => state.menus,
  products: (state: MenuState): Product[] =>
    getters
      .currentMenu(state)
      ?.products?.filter(
        (product) =>
          product.type !== PRODUCT_TYPE.FOR &&
          !getters.formulaZones(state).some((zone) => zone.code === product.zoneCode)
      )
      .sort((a, b) => (a.zoneCode < b.zoneCode ? -1 : 1)) || [],
  service: (state: MenuState): Service | null => state.selectedService,
  services: (state: MenuState): Service[] =>
    state.services
      .filter((service) => getters.hasProducts(state)(service))
      .sort((a, b) => (a.startAt < b.startAt ? -1 : 1)),
  zone:
    (state: MenuState) =>
    (code: string): Zone | null =>
      state.zones.find((zone) => zone.code === code) || null,
  zones: (state: MenuState): Zone[] => state.zones,
};
